import { InstanceScreen } from 'component/navigation/instance';

export default function DeveloperToolsIndexScreen() {
    return <InstanceScreen />;
}
